module.exports = __webpack_public_path__ + "img/pie-emoji.0d89b4ab.png";